import styled from 'styled-components';
import { media } from '../../utilities/style-utilities';
import { emy, fontEdenredLight } from '../../utilities/utilities';

const H1 = styled.h1`
    font-family: ${props => props.fontFamily ? props.fontFamily : fontEdenredLight};
    color: ${props => props.textColor ? props.textColor : '#0d1b58'};
    font-size: ${props => props.fontSize ? props.fontSize : emy(42.08)};
    font-weight: 400;
    text-align: center;
    margin: 0;
    width: 100%;

    ${ media.mobile`
        font-size: 2em;
        padding: 0 1rem;
    `}
`;

export default H1;


// WEBPACK FOOTER //
// ./src/collections/H1/H1.js